import { createMachine, assign } from 'xstate'

export type WorkOrderStates =
  | 'emailCollection'
  | 'setDescription'
  | 'attachPhotos'
  | 'workOrderSubmitted'

type WorkOrderMachineStates =
  { value: WorkOrderStates, context: WorkOrderRequest }

type WorkOrderCreationEvents =
  | { type: 'NEXT', value: any }
  | { type: 'NEW' }
  | { type: 'PREV' }
  | { type: 'UPDATE', value: any }
  | { type: 'LOGOUT' }
  | { type: 'RESET' }

const update = (key?: keyof WorkOrderRequest) => {
  if (key !== undefined) {
    return {
      UPDATE: {
        actions: assign((context: WorkOrderRequest, event: any) => {
          return {
            ...context,
            [key]: event.value,
          }
        }),
      },
    }
  }

  /* Resets context when placing a new Work Order */
  return {
    UPDATE: {
      actions: assign((context: WorkOrderRequest) => {
        return initialContext
      }),
    },
  }
}

const reset = () => {
  return {
    RESET: {
      actions: assign((context: WorkOrderRequest) => {
        return initialContext
      }),
    },
  }
}

const initialContext: WorkOrderRequest = {
  email: '',
  photos: [],
  details: {
    description: '',
    urgent: false,
    afterHours: false,
  },
}

export const workOrderMachine = createMachine<WorkOrderRequest, WorkOrderCreationEvents, WorkOrderMachineStates>({
  id: 'workOrder',
  initial: 'emailCollection',
  context: initialContext,
  states: {
    emailCollection: {
      on: {
        ...update('email'),
        NEXT: 'attachPhotos',
      },
    },
    attachPhotos: {
      on: {
        ...update('photos'),
        ...reset(),
        LOGOUT: 'emailCollection',
        PREV: 'emailCollection',
        NEXT: 'setDescription',
      },
    },
    setDescription: {
      on: {
        ...update('details'),
        ...reset(),
        LOGOUT: 'emailCollection',
        PREV: 'attachPhotos',
        NEXT: 'workOrderSubmitted',
      },
    },
    workOrderSubmitted: {
      on: {
        ...update(),
        ...reset(),
        LOGOUT: 'emailCollection',
        NEW: 'attachPhotos',
      },
    },
  },
})
